import * as Types from '../types';

import gql from 'graphql-tag';
export type BetFragment = { __typename?: 'V3_Bet', id: string, actor: string, amount: string, status: Types.BetStatus, potentialPayout: string, payout?: string | null, result?: Types.BetResult | null, odds: string, settledOdds?: string | null, redeemedTxHash?: string | null, affiliate: string, isRedeemed: boolean, isRedeemable: boolean, isCashedOut: boolean, freebetId?: string | null, isFreebetAmountReturnable?: boolean | null, paymasterContractAddress?: string | null, tokenId: string, createdAt: string, resolvedAt?: string | null, txHash: string, redeemedAt?: string | null, core: { __typename?: 'CoreContract', address: string, liquidityPool: { __typename?: 'LiquidityPoolContract', address: string } }, selections: Array<{ __typename?: 'V3_Selection', odds: string, result?: Types.SelectionResult | null, conditionKind: Types.V3_SelectionConditionKind, outcome: { __typename?: 'V3_Outcome', outcomeId: string, title?: string | null, condition: { __typename?: 'V3_Condition', conditionId: string, title?: string | null, status: Types.ConditionStatus, gameId: string, wonOutcomeIds?: Array<string> | null } } }>, cashout?: { __typename?: 'Cashout', payout: string } | null };

export const BetFragmentDoc = gql`
    fragment Bet on V3_Bet {
  id
  tokenId: betId
  actor
  amount
  status
  potentialPayout
  payout
  result
  odds
  settledOdds
  createdAt: createdBlockTimestamp
  resolvedAt: resolvedBlockTimestamp
  txHash: createdTxHash
  redeemedTxHash
  redeemedAt: redeemedBlockTimestamp
  affiliate
  isRedeemed
  isRedeemable
  isCashedOut
  core {
    address
    liquidityPool {
      address
    }
  }
  selections {
    odds
    result
    conditionKind
    outcome {
      outcomeId
      title
      condition {
        conditionId
        title
        status
        gameId
        wonOutcomeIds
      }
    }
  }
  freebetId
  isFreebetAmountReturnable
  paymasterContractAddress
  cashout {
    payout
  }
}
    `;